/**
 * Asks before a clinic page is left with typed input that was never saved or sent (PRA-010).
 */
import { useEffect, useRef, useState } from "react";
import { ConfirmDialog } from "@lattice/ui/ConfirmDialog";
import { guardNavigation } from "../router.ts";

export function LeaveGuard({
  dirty,
  what,
}: {
  readonly dirty: boolean;
  /** What would be lost, as it reads in the question: "your changes". */
  readonly what: string;
}) {
  const [leave, setLeave] = useState<(() => void) | null>(null);
  const isDirty = useRef(dirty);

  isDirty.current = dirty;

  useEffect(
    () =>
      guardNavigation({
        dirty: () => isDirty.current,
        ask: (go) => setLeave(() => go),
      }),
    [],
  );

  return (
    <ConfirmDialog
      open={leave !== null}
      onClose={() => setLeave(null)}
      title="Discard unsaved changes?"
      tone="danger"
      confirmLabel="Discard changes"
      cancelLabel="Keep editing"
      testId="leave-guard"
      onConfirm={() => {
        const go = leave;

        setLeave(null);
        go?.();

        return Promise.resolve(null);
      }}
    >
      {`You'll lose ${what}.`}
    </ConfirmDialog>
  );
}
